import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { Redirect, withRouter } from 'react-router'
import { StoreProps } from 'src/stores'
import { WizardContactGrid } from 'src/components/containers/wizard/WizardContainer'
import FormContactButton from 'src/components/atoms/wizard/FormContactButton'
import TextInput from 'src/components/atoms/wizard/TextInput'
import {
  RadioButton,
  RadioGroupContact
} from 'src/components/atoms/input/RadioButton'
import { FuneralType, PlanningReason } from 'src/resources'
import CustomFormContainer from 'src/components/containers/wizard/CustomFormContainer'
import TopInfoContainer from 'src/components/containers/wizard/TopInfoContainer'
import SideBarContainer from 'src/components/containers/wizard/SideBarContainer'
import SideBarSlider from 'src/components/molecules/wizard/SideBarSlider'
import FormInfoContainer from 'src/components/containers/wizard/FormInfoContainer'
import OpinionContainer from 'src/components/containers/wizard/OpinionContainer'
import OpinionSlider from 'src/components/molecules/wizard/OpinionSlider'
import FakePlanningSlider from 'src/components/molecules/wizard/FakePlanningSlider'
import FakePlanningContainer from 'src/components/containers/wizard/FakePlanningSliderContainer'

const trustedShops = require('src/assets/redesign/trusted_shops_logo.png')
const proven = require('src/assets/wizard/contact/proven.png')
const funeralHomeCertificate = require('src/assets/wizard/funeralHomeCertificate.png')
const offerImage = require('src/assets/wizard/benu-offer.png')

interface Props extends StoreProps {
  match?: any
}

interface State {
  offerLoading: boolean
  formErrorGreeting: string
  formErrorFirstName: string
  formErrorLastName: string
  formErrorEmail: string
  formErrorPhone: string
}

@inject('wizardStore')
@observer
export class WizardContact extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      offerLoading: false,
      formErrorGreeting: '',
      formErrorFirstName: '',
      formErrorLastName: '',
      formErrorEmail: '',
      formErrorPhone: ''
    }
  }

  componentWillMount() {
    const { wizardStore, match } = this.props
    if (!wizardStore.uuid) wizardStore.uuid = match.params.uuid
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_contact' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_contact' })
  }

  stringifyPlanningReason = (pr: PlanningReason) => {
    switch (pr) {
      case 'ACUTE_BEREAVEMENT':
        return 'Eingetretener Trauerfall'
      case 'IMPENDING_BEREAVEMENT':
        return 'Bevorstehender Trauerfall'
      case 'PROVISION':
        return 'Bestattungsvorsorge'
      default:
        return ''
    }
  }

  stringifyFuneralType = (ft: FuneralType) => {
    switch (ft) {
      case 'BURIAL':
        return 'Erdbestattung'
      case 'CREMATION':
        return 'Feuerbestattung'
      case 'TREE_FUNERAL':
        return 'Baumbestattung'
      case 'SEA_FUNERAL':
        return 'Donaubestattung'
      default:
        return ''
    }
  }

  setFirstNameError = (e) => {}

  setGreeting = (e) => {
    const { wizardStore } = this.props
    this.setState({ formErrorGreeting: '' })
    wizardStore.contactDetails.greeting = e.target.value
  }

  setFirstname = (e) => {
    const { wizardStore } = this.props
    this.setState({ formErrorFirstName: '' })
    wizardStore.contactDetails.firstName = e
  }

  setLastname = (e) => {
    const { wizardStore } = this.props
    this.setState({ formErrorLastName: '' })
    wizardStore.contactDetails.lastName = e
  }

  setEmail = (e) => {
    const { wizardStore } = this.props
    this.setState({ formErrorEmail: '' })
    wizardStore.contactDetails.email = e
  }

  setPhone = (e) => {
    const { wizardStore } = this.props
    this.setState({ formErrorPhone: '' })
    wizardStore.contactDetails.phone = e
  }

  setErrorGreeting = (e) => {
    this.setState({ formErrorGreeting: !e ? 'Bitte Anrede auswählen' : '' })
  }

  setErrorFirstname = (e) => {
    this.setState({ formErrorFirstName: !e ? 'Bitte Vorname angeben' : '' })
  }

  setErrorLastname = (e) => {
    this.setState({ formErrorLastName: !e ? ' Bitte Nachname angeben' : '' })
  }

  setErrorEmail = (e) => {
    this.setState({
      formErrorEmail: !e
        ? 'Ihre E-Mail benötigen wir zur Angebotsversendung.'
        : ''
    })
  }

  setErrorPhone = (e) => {
    this.setState({
      formErrorPhone: !e
        ? 'Ihre Telefonnummer benötigen wir für Rückfragen bei der Angebotserstellung.'
        : ''
    })
  }

  validEmail = (email) => {
    return (
      email &&
      email.length > 4 &&
      email.split('@').length === 2 &&
      email.includes('.') &&
      (email.indexOf(' ') === email.length - 1 || email.indexOf(' ') === -1)
    )
  }

  validGreeting = (gretting) => {
    return gretting !== null ? true : false
  }

  validName = (name) => {
    return name && name.length > 0 && !/\d/.test(name)
  }

  validPhone = (phone) => {
    return phone && phone.length > 5 && !!parseFloat(phone)
  }

  validForm = () => {
    const {
      greeting,
      firstName,
      lastName,
      email,
      phone
    } = this.props.wizardStore.contactDetails
    return (
      this.validGreeting(greeting) &&
      this.validEmail(email) &&
      this.validName(firstName) &&
      this.validName(lastName) &&
      this.validPhone(phone)
    )
  }

  submit = () => {
    const {
      greeting,
      firstName,
      lastName,
      email,
      phone
    } = this.props.wizardStore.contactDetails
    if (this.validForm()) {
      const { wizardStore } = this.props
      this.setState({ offerLoading: true })
      wizardStore.saveContacts(() => {
        this.setState({ offerLoading: false })
      })
    } else {
      this.setErrorGreeting(this.validGreeting(greeting))
      this.setErrorFirstname(this.validName(firstName))
      this.setErrorLastname(this.validName(lastName))
      this.setErrorEmail(this.validEmail(email))
      this.setErrorPhone(this.validPhone(phone))
    }
  }

  redirectToConfigurator = () => {
    const { wizardStore } = this.props
    let urlAdd = ''
    if (wizardStore.basics.planningReason === 'ACUTE_BEREAVEMENT')
      urlAdd = 'eingetreten'
    if (wizardStore.basics.planningReason === 'IMPENDING_BEREAVEMENT')
      urlAdd = 'bevorstehend'
    if (wizardStore.basics.planningReason === 'PROVISION') urlAdd = 'vorsorge'
    let location = 'location=austria'
    if(wizardStore.location.zipCode.startsWith("1")) location = "location=vienna"
    return (
      <Redirect
        to={`/planung/${urlAdd}/detailplanung/${wizardStore.uuid}?neu&${wizardStore.basics.planningReason}&${location}`}
      />
    )
  }

  render() {
    const { wizardStore } = this.props
    const {
      // greeting,
      firstName,
      lastName,
      email,
      phone
    } = wizardStore.contactDetails

    const {
      offerLoading,
      formErrorEmail,
      formErrorGreeting,
      formErrorFirstName,
      formErrorLastName,
      formErrorPhone
    } = this.state

    if (!offerLoading && wizardStore.isOfferFinished)
      return this.redirectToConfigurator()

    return (
      <WizardContactGrid>
        <TopInfoContainer>
          <div className='awards'>
            <div className='star-containers'>
              ⭐⭐⭐⭐⭐
              <br /> Mehr als 1.000 betreute Familien
            </div>
            <div className='image-containers'>
              <img src={funeralHomeCertificate} />
              <img src={trustedShops} />
              <img src={proven} />
            </div>
          </div>
          <div className='container'>
            <div className='info'>
              <h2>Transparentes Angebot inkl. Friedhofs­gebühren erstellt!</h2>
              <p>
                Im nächsten Schritt sehen Sie Ihr Angebot und können dieses{' '}
                <u>nach Ihren Wünschen</u> anpassen. Ihre bisherige Auswahl:
              </p>
              <ul>
                <li>
                  <p>
                    {' '}
                    <i className='fas fa-check'></i> <strong>Anliegen</strong>{' '}
                    <span id='anliegen'>
                      {this.stringifyPlanningReason(
                        wizardStore.basics.planningReason
                      )}
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    {' '}
                    <i className='fas fa-check'></i>{' '}
                    <strong>Bestattungsart</strong>{' '}
                    <span id='art'>
                      {this.stringifyFuneralType(
                        wizardStore.basics.funeralType
                      )}
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    {' '}
                    <i className='fas fa-check'></i>{' '}
                    <strong>
                      {wizardStore.location.city ? 'Ort' : 'Postleitzahl'}{' '}
                    </strong>
                    <span id='ort'>
                      {wizardStore.location.city
                        ? wizardStore.location.zipCode +
                          ', ' +
                          wizardStore.location.city
                        : wizardStore.location.zipCode}
                    </span>
                  </p>
                </li>
              </ul>
            </div>
            <img src={offerImage} />
          </div>
        </TopInfoContainer>
        <FakePlanningContainer>
          <FakePlanningSlider />
        </FakePlanningContainer>
        <CustomFormContainer>
          <h2>Für Ihr Angebot benötigen wir noch folgende Daten:</h2>
          <TextFieldContainer>
            <label>Anrede</label>
            {/* <DropDown
            items={genderList}
            onSelect={(t) => this.setGreeting(t)}
            placeholder='Anrede wählen'
          /> */}
            <RadioGroupContact errorMessage={formErrorGreeting}>
              <RadioButton
                name='gender'
                label='Frau'
                value='MRS'
                onClick={this.setGreeting}
                // defaultChecked={!greeting}
                inline
              />
              <RadioButton
                name='gender'
                label='Herr'
                value='MR'
                onClick={this.setGreeting}
                // defaultChecked={!greeting}
                inline
              />
            </RadioGroupContact>
            <label>Vorname</label>
            <TextInput
              value={firstName}
              name='firstname'
              placeholder='Vorname *'
              onChange={this.setFirstname}
              validate={this.validName}
              errorMessage={formErrorFirstName}
            />
            <label>Nachname</label>
            <TextInput
              value={lastName}
              name='lastname'
              placeholder='Nachname *'
              onChange={this.setLastname}
              validate={this.validName}
              errorMessage={formErrorLastName}
            />
            <label>E-Mail</label>
            <TextInput
              value={email}
              name='email'
              placeholder='E-Mail *'
              onChange={this.setEmail}
              validate={this.validEmail}
              errorMessage={formErrorEmail}
            />
            <label>Telefon</label>
            <TextInput
              value={phone}
              name='phone'
              placeholder='Telefon *'
              type='tel'
              onChange={this.setPhone}
              validate={this.validPhone}
              errorMessage={formErrorPhone}
            />
          </TextFieldContainer>
          <FormContactButton
            preventLink
            text={offerLoading ? 'Lädt...' : 'ANGEBOT ANSEHEN ➜'}
            // disabled={!this.validForm()}
            addOn={this.submit}
          />
          <h3>
            <i className='fas fa-check' />
            Ihre Anfrage ist kostenfrei und unverbindlich!
          </h3>
        </CustomFormContainer>

        <SideBarContainer>
          <h2>Unsere Experten</h2>
          <SideBarSlider />
          <ul>
            <li>
              <i className='fas fa-check' />
              Kostenlose Beratung
            </li>
            <li>
              <i className='fas fa-check' />
              Unverbindliches Angebot
            </li>
            <li>
              <i className='fas fa-check' />
              100% Kostentransparenz
            </li>
          </ul>
        </SideBarContainer>
        <FormInfoContainer>
          <div className='lock'>
            <i className='fas fa-lock' />
          </div>
          <p>
            Ihre Kontaktdaten werden <b>ausschließlich zu Ihrer Beratung</b>{' '}
            verwendet. Sie erklären sich damit einverstanden, dass Benu sie
            telefonisch und per E-Mail kontaktiert.
          </p>
        </FormInfoContainer>
        <OpinionContainer>
          <OpinionSlider />
        </OpinionContainer>
      </WizardContactGrid>
    )
  }
}

const TextFieldContainer = styled.div`
  width: 100%;
`

export default withRouter(WizardContact)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/WizardContact.tsx